module.exports = __webpack_public_path__ + "static/media/29.b6c6a846.jpg";